/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "social-twitter-square-inline-f9ecd38d--sprite",
  "use": "social-twitter-square-inline-f9ecd38d--sprite-usage",
  "viewBox": "0 0 19 15.441",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 15.441\" id=\"social-twitter-square-inline-f9ecd38d--sprite\"><path d=\"M850.054,280.3a11.016,11.016,0,0,0,11.091-11.091c0-.169,0-.337-.011-.5a7.931,7.931,0,0,0,1.945-2.018,7.778,7.778,0,0,1-2.239.614,3.912,3.912,0,0,0,1.714-2.156,7.813,7.813,0,0,1-2.475.946,3.9,3.9,0,0,0-6.643,3.555,11.067,11.067,0,0,1-8.035-4.073,3.9,3.9,0,0,0,1.207,5.2,3.87,3.87,0,0,1-1.765-.488c0,.016,0,.033,0,.05a3.9,3.9,0,0,0,3.127,3.822,3.894,3.894,0,0,1-1.76.067,3.9,3.9,0,0,0,3.642,2.707,7.822,7.822,0,0,1-4.841,1.669,7.953,7.953,0,0,1-.93-.054,11.036,11.036,0,0,0,5.975,1.751\" transform=\"translate(-844.079 -264.859)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
